module.exports = __webpack_public_path__ + "static/datatable-format-dont-2e40fb8117df26b8b9aac4bc27affea0.png";